import React, { Component } from 'react';
import { Data } from 'react-data-grid-addons';
import { Row, Col, Button } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { UI_HEIGHT } from '../Common/constants';

class ReturnModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
      needsDelete: false,
      rowsToDelete: 0,
      finished: false,
      oldLoaded: 0,
      changed: false,
      weights: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      changeStyle: false,
    };
  }

  componentDidMount() {
    const newRows = [...this.props.currentWeights.Weights];
    for (let i = 0; i < newRows.length; i += 1) {
      newRows[i] = { Weight: newRows[i] };
    }
    const newWeights = { ...this.state.weights, rows: newRows };
    this.setState({ weights: newWeights });
  }

  // componentWillReceiveProps(nextProps) {
  //   if (!this.state.oldLoaded) {
  //     this.setState({ oldLoaded: nextProps.salesOrderLineWeights.length });
  //   }
  //   if ((parseFloat(nextProps.totalLoaded) < nextProps.salesOrderLineWeights.length) && !this.state.finished) {
  //     const rowsToDelete = nextProps.salesOrderLineWeights.length - nextProps.totalLoaded;
  //     this.setState({ needsDelete: true, rowsToDelete });
  //   } else {
  //     this.setState({ needsDelete: false });
  //   }
  //   if (nextProps.totalWeight !== this.props.totalWeight) {
  //     let avgWeight = (parseFloat(nextProps.totalWeight) || 0) / (parseFloat(this.state.weights.rows.length) || 1);
  //     avgWeight = avgWeight.toFixed(2);
  //     this.state.weights.rows.map(r => {
  //       r.Weight = avgWeight;
  //     })
  //   }
  //   if (nextProps.salesOrderLineWeights && nextProps.salesOrderLineWeights !== this.props.salesOrderLineWeights) {
  //     let tempWeights = [];
  //
  //     nextProps.salesOrderLineWeights.map(weight => {
  //       tempWeights.push({ Weight: weight });
  //     });
  //
  //     if (nextProps.salesOrderLineWeights.length >= this.props.totalLoaded) {
  //       const newWeights = tempWeights; // .splice(0, parseInt(this.props.totalLoaded));
  //       const weights = { ...this.state.weights, rows: newWeights };
  //       this.setState({ weights });
  //     } else {
  //       const temp = tempWeights.length;
  //       for (let i = 0; i < (this.props.totalLoaded - temp); i += 1) {
  //         tempWeights.push({ Weight: 0 });
  //       }
  //       const weights = { ...this.state.weights, rows: tempWeights };
  //       this.setState({ weights });
  //     }
  //   }
  // }

  componentWillUnmount() {
    if (!this.state.changed) {
      this.props.keepLoaded(this.state.oldLoaded);
    }
    this.props.clearSalesOrderLineWeights();
  }

  fillWithLastValue() {
    let index = 0;
    const newWeights = { ...this.state.weights };

    for (let i = 0; i < this.state.weights.rows.length; i += 1) {
      if (this.state.weights.rows[i].Weight === 0) {
        index = i;
        break;
      }
    }
    if (index > 0) {
      const fillValue = this.state.weights.rows[index - 1].Weight;

      for (let i = index; i < this.state.weights.rows.length; i += 1) {
        newWeights.rows[i].Weight = fillValue;
      }
      this.setState({ weights: newWeights });
    }
  }

  clearAllValues() {
    const newWeights = [...this.state.weights.rows];
    newWeights.map(row => {
      row.Weight = 0;
    });

    const  weights = { ...this.state.weights, rows: newWeights }
    this.setState({ weights });
  }

  renderWeightInputs() {
    const { salesOrderLineWeightsIsLoading, salesOrderLineWeightsError } = this.props;
    if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) {
      return <Spinner className="marginTopStyle" />;
    } else if (salesOrderLineWeightsError) {
      return (
        <div className="alert alert-danger">
          {JSON.stringify(salesOrderLineWeightsError)}
        </div>
      );
    }
    const getRows = () => {
      return Data.Selectors.getRows(this.state.weights);
    }

    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      var rows = getRows();
      return Object.assign({Idx: rowIdx+1}, rows[rowIdx]);
    }

      // Handle the row select function

      const onRowsSelected = (rows) => {
        let newRows = getRows();
        let selectedRows = [];
        rows.map(r => {
          newRows[r.rowIdx].isSelected = true;
        });
        newRows.map(r => {
          if(r.isSelected == true) {
            selectedRows.push(r);
          }
        });
        this.setState({ rows: newRows, selectedRows: selectedRows });
      }
      const onRowsDeselected = (rows) => {
          let newRows = getRows();
          let selectedRows = [];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = false;
          });
          newRows.map(r => {
            if(r.isSelected == true) {
              selectedRows.push(r);
            }
          });
          this.setState({ rows: newRows, selectedRows: selectedRows });
      }


      const handleRowUpdated = e => {
          let rows = this.state.weights.rows.slice(0);
          Object.assign(rows[e.rowIdx], e.updated);
          let weights = { ...this.state.weights, rows: rows }
          this.setState({ weights });
      }

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
          var weights = Object.assign({}, this.state.weights, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({ weights });
      }

      //Custom Formatter component

      const DateFormatter = React.createClass({
          render() {
              if (this.props.value) {
                let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                let date = new Date(this.props.value)
                let index = dateMap.indexOf(date.toString().slice(4,3));
                let localDate = index + date.toString().slice(8, 6);
                return <span>{date.toString().slice(4, 15)}</span>;;
              }
              else return <span className="label label-danger">-</span>;
          }
      });

      let that = this;

      const deleteFormatter = React.createClass({
          render() {
            return(
              <span>
                <Button
                bsStyle="danger"
                className="textAlignStyle"
                onClick={() => {
                /*var ProductNum = this.props.dependentValues.ProductNum;
                that.removeRow(ProductNum);*/
                let weights = that.state.weights;
                weights.rows.splice(this.props.dependentValues.Idx - 1, 1);
                let rowsToDelete = that.state.rowsToDelete - 1;
                if (rowsToDelete === 0){
                  that.setState({needsDelete: false, rowsToDelete , weights, finished: true});
                } else {
                  that.setState({rowsToDelete, weights});
                }
              }}>X</Button>
            </span>);
          }
      });


      // Column difinition

      const columns = [
        {
            key: 'Idx',
            name: <Translate value="idx" />,
            width: 40,
            resizable: false,
            filterable: true,
        },
        {
            key: 'Weight',
            name: <Translate value="weight" />,
            width: 100,
            resizable: true,
            filterable: true,
        },
      ];
      return (
          <Row>
            <Col sm={ 11 }>
              <div style={{ maxWidth: '99%'}} id="ReturnModal-dataGrid1">
                <span>Please choose what you want to return</span>
                <ReactDataGrid
                    style={{ height: '10%' }}
                    onGridSort={handleGridSort}
                    columns={columns}
                    enableCellSelect={true}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                    minHeight={275}
                    onRowUpdated={handleRowUpdated}
                    enableRowSelect="multi"
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}
                    disable
                  />
              </div>
            </Col>
          </Row>
      )
}

  render() {
    const { closeC } = this.props;

    return (
      <ContentWrapper>
        <hr/>
        {(this.props.invoice) ? this.renderWeightInputs() : ""}
        <br/>
        {
          (!this.props.invoice) ?
          <div>
            <Row>
              <button className="btn btn-primary col-sm-11 buttonStyle" disabled={this.state.needsDelete} onClick={() => {
                  this.props.setOrderLineWeights(this.props.rowChosen, this.state.weights.rows);
                  this.setState({ changed: true });
                  let totalWeight = 0;
                  this.state.weights.rows.map(row => {
                    if (row.Weight)
                      totalWeight += parseFloat(row.Weight);
                  });
                  this.props.returnTotalWeight(totalWeight.toFixed(2));
                  // this.props.closeC();
                }}><Translate value="save_weights" /></button>
            </Row>
            <br/>
            <Row>
              <button className="btn btn-danger col-sm-11 buttonStyle" disabled={this.state.needsDelete} onClick={() => {this.props.closeC()}}><Translate value="discard_changes" /></button>
            </Row>
          </div> :
          <div>
            <Row>
              <button className={(this.state.changeStyle) ? "btn btn-success col-sm-11 buttonStyle" : "btn btn-primary col-sm-11 buttonStyle"} disabled={this.state.needsDelete} onClick={() => {
                  this.setState({ changeStyle: true, changed: true });
                  let totalWeight = 0;
                  this.state.weights.rows.map(row => {
                    if (row.Weight && row.isSelected)
                      totalWeight += parseFloat(row.Weight);
                  });
                  this.props.setWeights(this.props.rowChosen, this.state.weights.rows, totalWeight.toFixed(4));
                  this.props.closeC();
                  // this.props.closeC();
                }}><Translate value="save_returns" /></button>
            </Row>
            <br/>
            <Row>
              <button className="btn btn-danger col-sm-11 buttonStyle" onClick={() => {this.props.closeC()}}><Translate value="close" /></button>
            </Row>
          </div>
        }
        <br/>
        <Row>
          {this.props.editSalesOrderLineWeightsError &&
          <div className="alert alert-danger">{this.props.editSalesOrderLineWeightsError}</div>}
          { (!this.props.invoice) ?
            <div>
              {this.props.salesOrderLineWeightsIsEditing &&
              <div className="alert alert-info"><Translate value="uploading" /></div>}
              {this.props.editSalesOrderLineWeightsSuccess &&
              <div className="alert alert-success"><Translate value="saved" /></div>}
            </div> :
            <span></span>
          }
        </Row>
      </ContentWrapper>
    )
  }
}

export default ReturnModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/returnModal.jsx